import type { FormatOptionLabelMeta, SingleValue } from 'react-select';

import { Select } from '@revelio/ui';

import { getFilterDefinition } from '../engine/filterRegistry';
import type { FilterId, FilterSelectOptions } from '../types/filters';
import styles from './filter-overlay-select.module.css';

interface FilterOption {
  label: string;
  value: FilterSelectOptions['id'];
  labelPostfix?: string;
}

interface FilterSelectDropdownProps {
  filterOptions: FilterSelectOptions[];
  selectedFilter: FilterId | null;
  onChangeSelectedFilter: (selected: SingleValue<FilterOption>) => void;
}

export const FilterSelectDropdown = ({
  filterOptions,
  selectedFilter,
  onChangeSelectedFilter,
}: FilterSelectDropdownProps) => {
  const selectedFilterDef = selectedFilter
    ? getFilterDefinition(selectedFilter)
    : null;
  const selectedFilterOption = filterOptions.find(
    (f) => f.id === selectedFilter
  );
  const selectedFilterName =
    selectedFilterDef?.name || selectedFilterOption?.name || '';
  const selectedFilterPostfix = selectedFilterOption?.labelPostfix;

  const formatOptionLabel = (
    option: FilterOption,
    meta: FormatOptionLabelMeta<FilterOption>
  ) => {
    if (meta.context !== 'value' || !option.labelPostfix) {
      return <span className={styles.labelText}>{option.label}</span>;
    }

    return (
      <span className={styles.labelRow}>
        <span className={styles.labelText}>{option.label}</span>
        <span className={styles.labelPostfix}>{option.labelPostfix}</span>
      </span>
    );
  };

  return (
    <Select<FilterOption>
      id="filter-type-select"
      options={filterOptions.map((option) => ({
        label: option.name,
        value: option.id,
        labelPostfix: option.labelPostfix,
      }))}
      value={
        selectedFilter
          ? {
              label: selectedFilterName,
              value: selectedFilter,
              labelPostfix: selectedFilterPostfix,
            }
          : null
      }
      formatOptionLabel={formatOptionLabel}
      onChange={(selected) => onChangeSelectedFilter(selected)}
      size="sm"
      className={styles.overlaySelect}
      classNamePrefix="filter-overlay-select"
    />
  );
};
